import state from './state'

const helper = {
  // setter
  setTopRightComponent: (component) => {
    state.topRightComponent = component
  },

  setMenuItemBubbleContentComponent: (component) => {
    state.menuItemBubbleContentComponent = component
  },

  setMenuItemBubbleLabelComponent: (component) => {
    state.menuItemBubbleLabelComponent = component
  },

  setMainBubbleContentComponent: (component) => {
    state.mainBubbleContentComponent = component
  },

  // getter
  getTopRightComponent: () => {
    return state.topRightComponent
  },

  getMenuItemBubbleContentComponent: () => {
    return state.menuItemBubbleContentComponent
  },

  getMenuItemBubbleLabelComponent: () => {
    return state.menuItemBubbleLabelComponent
  },

  getMainBubbleContentComponent: () => {
    return state.mainBubbleContentComponent
  }
}

export default helper
